import { validateTidalLicense } from "../base/index.js";
import "../global.d.js";
import "./extend.tidal.theme.js";
export * from "./theme/index.js";
validateTidalLicense();
//# sourceMappingURL=index.js.map
